import { AnimatePresence, motion } from "framer-motion";
import { AlertTriangle, X } from "lucide-react";
import type { ProtocolError } from "../../types/protocol";

export const ErrorToast = ({ error, onDismiss }: { error: ProtocolError | null; onDismiss: () => void }) => (
  <AnimatePresence>
    {error && (
      <motion.div
        className="error-toast"
        role="alert"
        initial={{ opacity: 0, y: 24, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 12, scale: 0.98 }}
      >
        <span className="error-toast__icon">
          <AlertTriangle size={18} aria-hidden="true" />
        </span>
        <span className="error-toast__copy">
          <strong>Un petit trou d’air</strong>
          <span>{error.message}</span>
        </span>
        <button className="icon-button" type="button" onClick={onDismiss} aria-label="Fermer le message">
          <X size={18} />
        </button>
      </motion.div>
    )}
  </AnimatePresence>
);
